var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOpenCamera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.98499 6.29761C7.05571 6.29761 6.29761 7.05846 6.29761 7.99113C6.29761 8.92379 7.05571 9.67237 7.98499 9.67237C8.91427 9.67237 9.67237 8.91152 9.67237 7.97885C9.67237 7.04619 8.91427 6.29761 7.98499 6.29761Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2492 4.69016H11.0796L10.4338 3.71743C10.1901 3.35265 9.76372 3.13379 9.3251 3.13379H6.64468C6.20606 3.13379 5.77963 3.35265 5.53596 3.71743L4.89022 4.69016H3.72058C2.97737 4.69016 2.38037 5.28596 2.38037 6.02767V10.7454C2.38037 11.4871 2.97737 12.0829 3.72058 12.0829H12.2492C12.9924 12.0829 13.5894 11.4871 13.5894 10.7454V6.02767C13.5894 5.28596 12.9924 4.69016 12.2492 4.69016ZM7.98489 10.9886C6.31572 10.9886 4.96332 9.63895 4.96332 7.97314C4.96332 6.30733 6.31572 4.96982 7.98489 4.96982C9.65406 4.96982 11.0065 6.31949 11.0065 7.9853C11.0065 9.63895 9.65406 10.9886 7.98489 10.9886ZM12.0786 6.57484C12.0664 6.57484 12.0543 6.57484 12.0299 6.57484H11.5425C11.3232 6.56268 11.1527 6.38029 11.1648 6.16142C11.177 5.95472 11.3354 5.79665 11.5425 5.78449H12.0299C12.2492 5.77233 12.432 5.94256 12.4441 6.16142C12.4563 6.38029 12.2979 6.56268 12.0786 6.57484Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open_camera.1df2590f.svg";
export { ForwardRef as ReactComponent };